// WP-0.7: placeholder page for every §18.2 route not yet built. Named by its screen id so
// the shell is fully navigable from P0; feature WPs replace these one screen at a time.
// Built on EmptyState (§18.1 inventory) so stub and real empty states share one look.
import { Construction } from 'lucide-react';
import { useLocation, useNavigate } from 'react-router-dom';
import { EmptyState } from '../components/EmptyState';

export function RouteStub({
  screenId,
  title,
}: {
  screenId: string;
  title: string;
}): React.JSX.Element {
  const navigate = useNavigate();
  const location = useLocation();
  const onDashboard = location.pathname === '/';
  return (
    <div data-testid={`stub-${screenId}`}>
      <h1 className="mb-4 text-xl font-semibold text-ink">{title}</h1>
      <EmptyState
        icon={Construction}
        message={`${screenId} — coming in a later work package.`}
        {...(onDashboard
          ? {}
          : {
              action: {
                label: 'Back to dashboard',
                onClick: () => {
                  navigate('/');
                },
              },
            })}
      />
    </div>
  );
}
